// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___2Agh_","container":"container___1Qxhw","button":"button___10ywX","header":"header___3LSzI","size":"size___SqlrT"};